import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";

import { api } from "../services/api/api";

export type RootState = {
  [api.reducerPath]: ReturnType<typeof api.reducer>;
};

export const store = 
  configureStore({
    reducer: {
      [api.reducerPath]: api.reducer
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(api.middleware),
  });

setupListeners(store.dispatch);

export default store;
